import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Button, Image, Typography } from '@iho-design-system/Loader';

/*
    - icons
*/
import InfoSVG from '../../../assets/images/help-desk/info.svg';

const authCheck = ({ reservesResult, requestType }) => {

    /*
        - login
    */
    const login = () => {
        const modalList = window?.IHO?.Fn?.bs?.modal || [];
        if (modalList.length === 0) return;
        const loginModal = modalList.find(item => item._element.id === 'login-by-mobile');
        if (!loginModal || !loginModal.show) return;
        loginModal.show();
    }

    return (

        <React.Fragment>

            {requestType.split(',')[2] === 'reserveList' &&
                <React.Fragment>
                    <Box
                        className={`w-100 my-sm`} />
                    {reservesResult !== 'unauthorized' &&
                        <Box
                            className={`d-flex flex-wrap align-item-start position-relative`}
                            ms={{
                                opacity: '0',
                                bottom: '-16px',
                                animation: 'chatAnimation 0.25s linear',
                                animationFillMode: 'forwards',
                                animationDelay: '0.5s',
                            }}>
                            <Box
                                className={`p-xs mx-xs mr-0 my-sm mb-0 rounded-circle`}
                                ms={{
                                    maxWidth: '60%',
                                    backgroundColor: 'var(--gray-medium)'
                                }}>
                                <Image
                                    src={InfoSVG}
                                    alt='info'
                                    ms={{
                                        width: '12px',
                                        height: '12px'
                                    }} />
                            </Box>
                            <Box
                                className={`px-md py-xs rounded-sm rounded-bottom-right-0 toggle-opaccity`}
                                ms={{
                                    maxWidth: '60%',
                                    backgroundColor: 'var(--gray-medium)'
                                }}>
                                {reservesResult !== 'empty' &&
                                    <Typography>
                                        لطفا رزرو مورد نظرتان را انتخاب یا کد پیگیری رزرو را وارد نمایید.
                                    </Typography>
                                }
                                {reservesResult === 'empty' &&
                                    <Typography>
                                        لیست رزروهای شما خالی است.
                                    </Typography>
                                }
                            </Box>
                        </Box>
                    }
                    {reservesResult === 'unauthorized' &&
                        <React.Fragment>
                            <Box
                                className={`w-100 my-sm`} />
                            <Box
                                className={`d-flex flex-wrap align-item-start position-relative`}
                                ms={{
                                    opacity: '0',
                                    bottom: '-16px',
                                    animation: 'chatAnimation 0.25s linear',
                                    animationFillMode: 'forwards',
                                    animationDelay: '0.5s',
                                }}>
                                <Box
                                    className={`p-xs mx-xs mr-0 my-sm mb-0 rounded-circle`}
                                    ms={{
                                        maxWidth: '60%',
                                        backgroundColor: 'var(--gray-medium)'
                                    }}>
                                    <Image
                                        src={InfoSVG}
                                        alt='info'
                                        ms={{
                                            width: '12px',
                                            height: '12px'
                                        }} />
                                </Box>
                                <Box
                                    className={`px-md py-xs rounded-sm rounded-bottom-right-0 toggle-opaccity`}
                                    ms={{
                                        maxWidth: '60%',
                                        backgroundColor: 'var(--gray-medium)'
                                    }}>
                                    <Typography>
                                        برای ادامه، لطفا وارد پنل کاربری خود شوید.
                                    </Typography>
                                    <Button
                                        onClick={login}
                                        className={`my-xs mt-0`}
                                        variant='filled'
                                        color='primary'
                                        size='sm'
                                        ms={{
                                            width: '100%'
                                        }}>
                                        ورود
                                    </Button>
                                </Box>
                            </Box>
                        </React.Fragment>
                    }
                </React.Fragment>
            }

        </React.Fragment>

    );

}

export default authCheck;